import { FC, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IBuilderProps } from "../../../../interfaces/student";
import { IResumeBuild } from "../../../../interfaces/services";
import DataTable from "../../../sub_components/tables/DataTable";
import Drawer from "../../../sub_components/student/resume/Drawer";
import { PDFViewer } from "../../../wrappers/PDFViewer";
import { useGetCareersMedia } from "../../../../hooks/misc";
import moment from "moment";
import SkeletonLoader from "../../../reusables/SkeletonLoader";
import { Icons } from "../../../../data/Assets";


const BuilderView: FC<IBuilderProps> = (props: IBuilderProps) => {
  const { builderData, isLoading } = props;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedResume, setSelectedResume] = useState<IResumeBuild | null>(null);
  const navigate = useNavigate();

  const { studentId: studentIdParam } = useParams();
  const studentId = studentIdParam ? parseInt(studentIdParam) : 0;

  // Get media data for selected resume
  const mediaId = selectedResume?.medias?.[0]?.id;
  const { data: mediaData, isLoading: isMediaLoading } = useGetCareersMedia(
    studentId ? Number(studentId) : 0,
    mediaId ? Number(mediaId) : 0
  );

  const columns = [
    {
      name: "Resume Title",
      identifier: "title",
      render: (row: IResumeBuild, index: number) => (row.title || row.job_title)
    },
    {
      name: "Job Title",
      identifier: "job_title",
    },
    {
      name: "Creation Date",
      identifier: "created_at",
    },
    {
      name: "Last Modified",
      identifier: "updated_at",
    }
  ];

  const handleCellClick = (id: number, studentId: number) => {
    const resume = builderData.find((item) => item.id === id);

    if (!resume || (!resume.title && !resume.job_title)) return;

    setSelectedResume(resume || null);
    toggleDrawer();
  };

  const handleTitleClick = (id: number, studentId: number) => {
    const selectedResume = builderData.find((item) => item.id === id);
    navigate(`/students/${studentId}/resume/${id}`, {
      state: { resumeData: selectedResume }
    });
  };

  const toggleDrawer = () => setIsDrawerOpen(!isDrawerOpen);

  // Get PDF URL for drawer
  const pdfUrl = mediaData?.url ?? null;

  return (
    <div className="immersion__student__resume__builder__page_view">
      {/* <div className="immersion__student__resume__builder_section">
        <div className="immersion__student__resume__builder_section_left">
          Icons temporarily hidden
          <div className="immersion__student__resume__builder_section_left_icons">
            <SVGIcon src={null} hoverColor="dark_grey" />
            <SVGIcon src={Icons.Trash3} hoverColor="dark_grey" />
          </div>

        </div>
        <div className="immersion__student__resume__builder_section_right">
          <div className="immersion__student__resume__builder_section_right_icons">
            <SVGIcon src={Icons.Filter} hoverColor="dark_grey" />
            <span className="font-sm">Filter</span>
          </div>
        </div>
      </div> */}
      <DataTable
        columns={columns}
        list={builderData}
        onCellClick={handleCellClick}
        onTitleClick={handleTitleClick}
        isLoading={isLoading}
        titleIdentifier="job_title"
        studentId={studentId}
      />

      <Drawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        title={selectedResume?.title || "Resume Preview"}
        closeIcon={Icons.X}
      >
        {isMediaLoading || !pdfUrl ? (
          <SkeletonLoader type="image" />
        ) : (
          <PDFViewer signedUrl={pdfUrl} scale={1} />
        )}
      </Drawer>
    </div>
  );
};

export default BuilderView;
